import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    width: '100%',

    '& .title': {
      fontSize: theme.size.xxl
    },

    '& .message': {
      marginTop: '0.75rem',
      fontSize: theme.size.base
    }
  },

  loading: {
    top: '70%'
  }
}))

export default useStyles
